import moment from 'moment'

export const onDateChange = (
    startDateChange: Date,
    endDateChange: Date,
    rainfall: boolean | null,
    recent: boolean,
    setStartDate: (startDate: Date) => void,
    setEndDate: (endDate: Date) => void,
    setShouldReloadData: (reloadData: boolean) => void,
    setShowButton: (showButton: boolean) => void,
    specifyTime: boolean
): void => {

    if (!specifyTime) {
        let finalDate = moment(endDateChange).toDate() >= moment().toDate() ? moment(endDateChange).toDate() : moment(endDateChange).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate()
        if (finalDate > moment().toDate()) {
            finalDate = moment().toDate()
        }
        const beginDate = moment(startDateChange).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
        setStartDate(beginDate)
        setEndDate(finalDate)
    } else {
        setStartDate(moment(startDateChange).toDate())
        setEndDate(moment(endDateChange).toDate())
    }

    if (recent) {
        setShouldReloadData(true)
    } else {
        setShowButton(true)
    }


}